class PermissionsService {
  static instance;
  permissions = [];

  constructor() {
    if (PermissionsService.instance) {
      return PermissionsService.instance;
    }
    PermissionsService.instance = this;
  }

  static getInstance() {
    if (!PermissionsService.instance) {
      PermissionsService.instance = new PermissionsService();
    }
    return PermissionsService.instance;
  }

  hasPermission(permission, teamId) {
    const teamPermissions = this.permissions.find(
      (perm) => perm.team_id === teamId
    );
    if (!teamPermissions) {
      return false;
    }
    return teamPermissions.permissions.includes(permission);
  }

  setPermissions(permissions) {
    this.permissions = permissions;
  }
}

export const permissionsService = PermissionsService.getInstance();
